class FastUTVMG1 extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.form = this.closest('form');
    this.groups = [...this.querySelectorAll('[data-option-index]')];
    this.variantInput = this.querySelector('input[name="id"]');
    this.button = this.querySelector('button[type="submit"]');
    this.status = this.querySelector('[data-status]');
    this.price = this.querySelector('[data-price]');
    this.initialPrice = this.price.textContent;
    try { this.variants = JSON.parse(this.querySelector('[data-variants]').textContent); }
    catch { this.variants = []; }
    this.stageIndex = this.groups.findIndex(group => group.dataset.optionName === 'Stage');
    this.fuelIndex = this.groups.findIndex(group => group.dataset.optionName === 'Fuel');
    this.styleIndex = this.groups.findIndex(group => group.dataset.optionName === 'Tuning style');
    this.enabled = this.dataset.enabled === 'true' && this.stageIndex >= 0 && this.fuelIndex >= 0 && this.styleIndex >= 0 && this.groups.length === 3;
    const selected = this.variants.find(variant => String(variant.id) === this.dataset.selectedVariant);
    if (selected) this.groups.forEach((group, index) => {
      for (const radio of group.querySelectorAll('input')) radio.checked = radio.value === selected.options[index];
    });
    this.addEventListener('change', event => {
      if (event.target.matches('input[type="radio"]')) this.update();
      if (event.target.matches('[data-model-family], [data-vehicle-year]')) this.validateFitment();
    });
    this.addEventListener('input', event => {
      if (event.target.matches('[data-vehicle-year]')) this.validateFitment();
      if (event.target.matches('[data-identification]')) event.target.setCustomValidity(event.target.value.trim() ? '' : this.dataset.required);
    });
    this.form.addEventListener('submit', event => {
      if (!this.current || !this.enabled || !this.current.available || this.variantInput.value !== String(this.current.id)) {
        event.preventDefault(); event.stopImmediatePropagation(); this.groups[0]?.querySelector('input:not(:disabled)')?.focus(); return;
      }
      for (const field of this.querySelectorAll('[data-identification]:not(:disabled)')) field.setCustomValidity(field.value.trim() ? '' : this.dataset.required);
      this.validateFitment();
      if (!this.form.reportValidity()) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
    this.form.addEventListener('formdata', event => {
      for (const group of this.groups) event.formData.delete(`mg1-option-${group.dataset.optionIndex}`);
    });
    this.update();
  }
  validateFitment() {
    const year = this.querySelector('[data-vehicle-year]');
    const family = this.querySelector('[data-model-family]').value;
    const minimum = family === 'Maverick R MAX (four-seat)' ? 2025 : 2024;
    year.setCustomValidity(family && year.value && Number(year.value) < minimum ? this.dataset.fitment : '');
  }
  update() {
    const stage = this.groups[this.stageIndex]?.querySelector('input:checked')?.value;
    const fuelGroup = this.groups[this.fuelIndex];
    if (fuelGroup) {
      const radios = [...fuelGroup.querySelectorAll('input')];
      const valid = radios.filter(radio => this.variants.some(variant => variant.options[this.stageIndex] === stage && variant.options[this.fuelIndex] === radio.value));
      for (const radio of radios) {
        radio.disabled = !valid.includes(radio);
        if (radio.disabled) radio.checked = false;
        radio.closest('label').classList.toggle('is-unavailable', radio.disabled);
      }
      if (valid.length === 1) valid[0].checked = true;
    }
    const options = this.groups.map(group => group.querySelector('input:checked')?.value);
    this.current = options.every(Boolean) ? this.variants.find(variant => variant.options.length === options.length && variant.options.every((option, index) => option === options[index])) : null;
    const exhaustField = this.querySelector('[data-exhaust-field]');
    const burble = this.groups[this.styleIndex]?.querySelector('input:checked')?.value === 'Burble/Flame';
    exhaustField.hidden = !burble;
    exhaustField.querySelector('input').disabled = !burble;
    exhaustField.querySelector('input').required = burble;
    const raceField = this.querySelector('[data-race-field]');
    const raceRequired = this.current?.options[this.stageIndex] === 'Stage 4';
    raceField.hidden = !raceRequired;
    const raceInput = raceField.querySelector('input');
    raceInput.disabled = !raceRequired;
    raceInput.required = raceRequired;
    const ready = this.enabled && this.current?.available === true;
    this.variantInput.disabled = !ready;
    this.variantInput.value = ready ? String(this.current.id) : '';
    this.button.disabled = !ready;
    this.button.setAttribute('aria-disabled', String(!ready));
    this.price.textContent = this.current ? this.current.priceLabel : this.initialPrice;
    this.querySelector('[data-selected-label]').textContent = this.current?.title || this.dataset.choose;
    this.status.textContent = !this.enabled ? this.dataset.held : this.current ? (ready ? this.dataset.ready : this.dataset.unavailable) : this.dataset.choose;
    this.querySelector('[data-stage-summary]').textContent = this.current?.summary || '';
    this.querySelector('[data-stage-requirements]').textContent = this.current?.requirements || '';
    this.querySelector('[data-stage-info]').hidden = !this.current?.summary && !this.current?.requirements;
  }
}
if (!customElements.get('fastutv-mg1')) customElements.define('fastutv-mg1', FastUTVMG1);
